import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from "../../utils/helpers";
import s from './FormControl.module.css';
import { Text } from "../text";
import { View } from "../view";
import { Provider, useFormControl } from './FormControl.context';
export const FormControl = ({ children, hasSuccess, hasError, group, disabled }) => {
    const WrapperTagName = group ? 'fieldset' : 'div';
    return (_jsx(WrapperTagName, { "data-testid": "st-formcontrol", children: _jsx(Provider, { value: { hasSuccess, hasError, group, disabled }, children: children }) }));
};
/* Private component */
export const FormControlCaption = ({ children, color = 'gray-500', className, }) => {
    const rootClassName = classNames(s.root, className);
    return (_jsx(View, { gap: 3, className: rootClassName, "data-testid": "form-control-caption", children: _jsx(Text, { as: "span", variant: "small-body", color: color, children: children }) }));
};
const FormControlHelper = ({ children, helperPosition = 'left', className }) => {
    const { hasError, disabled, hasSuccess } = useFormControl();
    const rootClassName = classNames(s.root, helperPosition && s[`helper-${helperPosition}`], className);
    if (hasError || hasSuccess)
        return null;
    return (_jsx(FormControlCaption, { className: rootClassName, color: disabled ? 'on-disabled' : 'gray-500', children: children }));
};
const FormControlError = ({ children, className }) => {
    const { hasError } = useFormControl();
    if (!hasError)
        return null;
    return (_jsx(FormControlCaption, { color: "error", className: className, children: children }));
};
const FormControlSuccess = ({ children, className }) => {
    const { hasSuccess } = useFormControl();
    if (!hasSuccess)
        return null;
    return (_jsx(FormControlCaption, { color: "success", className: className, children: children }));
};
FormControl.displayName = 'FormControl';
FormControlError.displayName = 'FormControl.Error';
FormControlHelper.displayName = 'FormControl.Helper';
FormControlSuccess.displayName = 'FormControl.Success';
FormControl.Helper = FormControlHelper;
FormControl.Success = FormControlSuccess;
FormControl.Error = FormControlError;
